<template>
  <div class>
    <v-toolbar dark :color="this.$gf.headerColor()">
      <v-toolbar-title>
        <v-icon class="icon">fa-gear</v-icon>Settings
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab small class="close" @click="closePanel">
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container>
      <v-layout>
        <v-flex xs12>
          <v-row class="mt-5" v-if="customizationLoading">
            <v-col cols="12">
              <v-skeleton-loader type="paragraph"></v-skeleton-loader>
            </v-col>
          </v-row>
          <v-row class="mt-5" v-else>
            <v-col cols="12">
              <div class="d-flex align-center">
                <!-- Icon -->
                <v-avatar color="green lighten-4" size="44">
                  <v-icon color="green darken-2">mdi-bell-ring</v-icon>
                </v-avatar>

                <!-- Title + Toggle -->
                <div class="ml-4 flex-grow-1">
                  <div class="ml-4 d-flex align-center flex-wrap">
                    <h3 class="font-weight-medium mb-0 mr-3">
                      Enable Notification Template Customization
                    </h3>
                    <v-switch v-model="settings.notification_customization" color="primary" hide-details
                      class="input_switch mt-0" @change="allowCustomization()"></v-switch>
                  </div>

                  <!-- Description -->
                  <p class="ml-4 mt-2 mb-0 text--secondary">
                    Allow company owners to customize email notification templates settings for their courses and
                    updates.
                  </p>
                </div>
              </div>
            </v-col>
            <v-col cols="12">
              <div class="d-flex align-center">
                <!-- Icon -->
                <v-avatar color="green lighten-4" size="44">
                  <v-icon color="green darken-2">mdi-palette</v-icon>
                </v-avatar>

                <!-- Title + Toggle -->
                <div class="ml-4 flex-grow-1">
                  <div class="ml-4 d-flex align-center flex-wrap">
                    <h3 class="font-weight-medium mb-0 mr-3">
                      Enable Theme Color Customization
                    </h3>
                    <v-switch v-model="settings.theme_customization" color="primary" hide-details
                      class="input_switch mt-0"></v-switch>
                  </div>

                  <!-- Description -->
                  <p class="ml-4 mt-2 mb-0 text--secondary">
                    Allow partners to customize their company's theme colors to match their brand identity and
                    preferences.
                  </p>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-flex>
      </v-layout>
    </v-container>
    <v-footer absolute height="68">
      <v-flex text-right>
        <v-btn v-if="loading" color="primary" loading></v-btn>
        <v-btn color="primary" large elevation="2" @click="saveCompanySettings" :disabled="customizationLoading" v-else>
          <v-icon left>mdi-content-save</v-icon>
          Save Changes
        </v-btn>
      </v-flex>
    </v-footer>
  </div>
</template>
<script>
import companyAPI from '@/api/company.js';

export default {
  name: "Settings",
  components: {
  },
  props: {
    id: {
      type: String,
      default: null
    },
  },
  data() {
    return {
      settings: [],
      customizationLoading: false,
      loading: false,
      successMessage: 'Company settings successfully updated.',
      errorMessage: 'Oops, something went wrong! Please check information is correct.'
    };
  },
  computed: {
  },
  watch: {
  },
  mounted() {
    this.getCompanySettings();
  },
  methods: {
    getCompanySettings() {
      this.customizationLoading = true;
      companyAPI
        .getCompanySettings(this.id)
        .then((resp) => {
          this.settings = resp.data.data;
          this.customizationLoading = false;
        });
    },
    saveCompanySettings() {
      this.loading = true;
      companyAPI
        .saveCompanySettings(this.id, this.settings)
        .then((resp) => {
          this.$snotify.success(this.successMessage);
          setTimeout(() => {
            this.$gf.removeBackdrop();
          }, 300);
          this.closePanel();
          this.loading = false;
        }).catch(err => {
          this.$snotify.error(this.errorMessage);
          this.loading = false;
          this.closePanel();
          setTimeout(() => {
            this.$gf.removeBackdrop();
          }, 300);
        });
    },
    closePanel() {
      this.$emit("closePanel", {});
    },
  }
};
</script>
